import type { Product } from '../../models/Product';
import type { SupabaseClient } from 'jsr:@supabase/supabase-js@2';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, name, description, price_id, interval, interval_count, type, price, currency`;

export class ProductRepository extends SupabaseRepository<Product> {
  constructor(client: SupabaseClient) {
    super('products', selector, client);
  }
}
